export default "__VITE_ASSET__Du1Ji4lu__"